/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="systemVersions.module.ts" />


module Meevo.Plugins.SystemVersions {

     class SystemVersionsController {
        context: ISystemVersionsContext;
         static $inject = [
             "meevo.AppSettings",
             "meevo.components.common.DataService",
             
             "meevo.components.busy.BusyService",
             ];
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService) {
            this.context = new SystemVersionsContext(
                appSettings,
                dataService,
                busyService
            );

            this.context.activate();
        }
    }

    angular.module("meevo.plugins.systemVersions")
        .controller("meevo.plugins.systemVersions.SystemVersionsController", SystemVersionsController);

}